export default __webpack_public_path__ + "static/media/3.dbdc7cb9.jpg";